export default __webpack_public_path__ + "static/media/single-user.9aa563a6.svg";